import './external-tools';
import initializeFoundation from './foundation';
import { initializeAnalytics } from './initializeAnalytics';
import './setupDatadog';
import './setupHoneybadger';
import './stickySidebar';
import './whatInput';

$(document).ready(initializeAnalytics);

$(document).ready(initializeFoundation);
